<template>
  <d-modal
    :key="'popup-pesel-preview-' + isVisible"
    :class="{ 'popup-form': true, 'is-hidden': !isVisible }"
    @close="onClosePopup"
    style="background-color: rgba(0,0,0,0.6)!important;">
    <d-modal-header>
      <d-modal-title>
        <h3 class="page-title">Podgląd danych pacjenta</h3>
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <div v-if="patient">
        <d-row>
          <d-col cols="12" md="6">
            <div class="form-group">
              <label>Imię:</label>
              <p>{{ patient.name || '—' }}</p>
            </div>
          </d-col>
          <d-col cols="12" md="6">
            <div class="form-group">
              <label>Nazwisko:</label>
              <p>{{ patient.last_name || '—' }}</p>
            </div>
          </d-col>
        </d-row>
        <d-row>
          <d-col cols="12" md="6">
            <div class="form-group">
              <label>PESEL:</label>
              <p>{{ patient.pesel || '—' }}</p>
            </div>
          </d-col>
          <d-col cols="12" md="6">
            <div class="form-group">
              <label>Data urodzenia:</label>
              <p>{{ patient.birthday_date || '—' }}</p>
            </div>
          </d-col>
        </d-row>
        <d-row>
          <d-col cols="12" md="6">
            <div class="form-group">
              <label>Miasto:</label>
              <p>{{ patient.city || '—' }}</p>
            </div>
          </d-col>
          <d-col cols="12" md="6">
            <div class="form-group">
              <label>Kod pocztowy:</label>
              <p>{{ patient.post_code || '—' }}</p>
            </div>
          </d-col>
        </d-row>
        <d-row>
          <d-col cols="12" md="6">
            <div class="form-group">
              <label>Ulica:</label>
              <p>{{ patient.street || '—' }}</p>
            </div>
          </d-col>
          <d-col cols="12" md="6">
            <div class="form-group">
              <label>Numer domu:</label>
              <p>{{ patient.number_home || '—' }}</p>
            </div>
          </d-col>
        </d-row>
        <d-row>
          <d-col cols="12" md="6">
            <div class="form-group">
              <label>Telefon:</label>
              <p>{{ patient.phone || '—' }}</p>
            </div>
          </d-col>
          <d-col cols="12" md="6">
            <div class="form-group">
              <label>E-mail:</label>
              <p>{{ patient.email || '—' }}</p>
            </div>
          </d-col>
        </d-row>
      </div>
      <div class="popup-box-buttons">
        <d-button
          theme="success"
          class="text-nowrap"
          @click.prevent="fillData">
          Uzupełnij dane
        </d-button>
        <d-button
          theme="info"
          class="text-nowrap ml-3"
          @click.prevent="refreshData">
          Odśwież dane
        </d-button>
        <d-button
          theme="secondary"
          class="text-nowrap ml-3"
          @click.prevent="onClosePopup">
          Zamknij
        </d-button>
      </div>
    </d-modal-body>
  </d-modal>
</template>

<script>
export default {
  name: 'pesel-preview-popup',
  props: {
    isVisible: {
      default: false,
      type: Boolean
    },
    patient: {
      default: null,
      type: Object
    },
    onClosePopup: {
      default: () => {},
      type: Function
    }
  },
  methods: {
    fillData() {
      this.$emit('fill', this.patient);
      this.onClosePopup();
    },
    refreshData() {
      this.$emit('refresh');
    }
  }
}
</script>
